
import Login from '@/views/login'
import Layouts from '../layout'
import React from 'react';
import Home from '@/views/home/home';
import SingleLogin from '@/views/singleLogin'
import { HashRouter as Router, Route, Redirect, Switch } from 'react-router-dom';

function RouterView() {
    return (
        <Router>
            <Switch>
                <Route
                    exact
                    path="/"
                >
                    <Redirect to="/login" />
                </Route>
                <Route
                    component={Login}
                    exact
                    path="/login"
                />
                <Route
                    component={SingleLogin}
                    exact
                    path="/singleLogin"
                />
                <Route component={Home}
                    exact
                    path="/home"
                />
                <Route component={Layouts} path="/"/>
            </Switch>
        </Router>
    );
}

export default RouterView;
